/* src/app/components/doc-viewer-new/dialogs/doc-viewer-history-dialog/doc-viewer-history-dialog.component.scss */
[dialog-body] {
  color: var(--text-color);
}
:host-context(.dark-theme) [dialog-body] {
  color: var(--text-color);
}
.audit-item {
  background-color: #E4E4E4;
  box-shadow: none;
  margin-bottom: 0px;
}
:host-context(.dark-theme) .audit-item {
  background-color: #424242;
}
/*# sourceMappingURL=doc-viewer-history-dialog.component.css.map */
